import wertverlustVerfolgen from "../../../assets/auto-bewerten/fahrzeugwert-iphone.webp";
import Image from "next/image";

export const WertverlustVerfolgen = () => {
  return (
    <div className="WertverlustVerfolgen-section">
      <div className="WertverlustVerfolgen">
        <div className="WV-text-wrapper">
          <h2>Verfolge die Entwicklung deiner Autobewertung</h2>
          <p>
            Mit dem Fahrzeug Bewertungstool kannst du sehen, was dein Auto
            aktuell wert ist und wie sich der Wert in den kommenden Monaten
            entwickeln wird.
          </p>
          <p>
            Die Nutzung des Tools ist kostenlos und zeigt dir Trends zur
            Autobewertung, damit du den besten Zeitpunkt für einen Verkauf
            planen kannst.
          </p>
          <p>
            Unsere Bewertungen basieren auf aktuellen Marktdaten und spiegeln
            die gegenwärtigen und sich ändernden Marktbedingungen für dein
            spezifisches Fahrzeug wider.
          </p>

          <p>
            Fast alle Autos verlieren im Laufe der Zeit an Wert, doch das Tempo
            und Ausmaß des Wertverlustes sind sehr unterschiedlich. Neben Alter,
            Kilometerstand und Servicehistorie beeinflussen auch externe
            Faktoren wie die Nachfrage nach Gebrauchtwagen und allgemeine
            Marktentwicklungen, welchen Preis du beim Verkauf erzielen kannst.
          </p>
        </div>
        <Image
          src={wertverlustVerfolgen}
          alt="wertverlust verfolgen"
          sizes="(max-width: 1040px) calc(100vw - 48px), 352px"
        />
      </div>
    </div>
  );
};
